
































import { Component, Prop, Vue } from 'vue-property-decorator'
import axios from 'axios'

@Component
export default class References extends Vue {
    @Prop() slug
    imageUrl: string = ''
    title: string = ''
    link: string = ''
    async created(): Promise<void> {
        if (this.slug) {
            const resp = await axios.get(
                `https://yvivre.com/wp-json/wp/v2/posts?slug=${this.slug}`
            )
            const post = resp.data[0]
            const featuredImageID = post.featured_media
            const respImage = await axios.get(
                `https://yvivre.com/wp-json/wp/v2/media/${featuredImageID}`
            )
            const image = respImage.data
            this.imageUrl = image.media_details.sizes['800'].source_url
            this.title = post.title.rendered
            this.link = post.link
        }
    }
}
